export default {
  internalWarranty: [],
  externalWarranty: [],
  allWarranty: [],
  warranty: [],
  optionWarranty: {},
  // Bulk update warranty
  bulkUpdateResults: [],
  bulkUpdateHistory: [], // Empty array - data will come from server with pagination
  bulkUpdateFilters: {
    dateFrom: '',
    dateTo: '',
    pcode: 'NR',
  },
};
